"use strict";
/****************************************************
 * Audit Information Platform Component
 * 搜索参照
 * 2020-08
 * Sunny <tufpsj@yonyou.com>
 ****************************************************/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
//----- Global ------
var React = require("react");
var react_1 = require("react");
//----- iUAP ------
var tinper_bee_1 = require("tinper-bee");
require("bee-button/build/Button.css");
//----- RefComponent -----
var TableRef_1 = require("./TableRef");
var TreeRef_1 = require("./TreeRef");
var SelectRef_1 = require("./SelectRef");
var TextRef_1 = require("./TextRef");
var NumberRef_1 = require("./NumberRef");
var NoRefSearch_1 = require("./NoRefSearch");
var Message_1 = require("./Message");
var CheckRef_1 = require("./CheckRef");
var RadioRef_1 = require("./RadioRef");
var NumberPlainRef_1 = require("./NumberPlainRef");
var DateRef_1 = require("./DateRef");
var Utils_1 = require("../utils/Utils");
require("../style/AIPSearchPanel.css");
var utils_1 = require("../utils");
var Const_1 = require("./Const");
/**
 * 参照项类型对应表
 */
var ComponentMap = {
    text: TextRef_1.default,
    number: NumberRef_1.default,
    tree: TreeRef_1.default,
    select: SelectRef_1.default,
    table: TableRef_1.default,
    checkbox: CheckRef_1.default,
    radio: RadioRef_1.default,
    number2: NumberPlainRef_1.default,
    date: DateRef_1.default,
};
/**
 * AIP参照搜索框组件
 *
 * @class AIPSearchPanel
 *
 * @extends { PureComponent }
 *
 * @description 配合参照设计显示搜索条件框
 *
 *
 * ### 涉及数据结构 ###
 *
 * - 服务返回的参照数据必须符合结构，详细规范参考类 ModelRef
 * ~~~json
 * {
 *    "createtime": "2021-03-09",
 *    "creator": null,
 *    "orderindex": null,
 *    "name": "科目余额表参照",
 *    "refType": null,
 *    "description": "科目余额表查询条件",
 *    "refitems": [
 *        {
 *            "valuefield": "账套编号",
 *            "defaultValue": null,
 *            "multiple": "0",
 *            "refitem": [],
 *            "pageable": false,
 *            "displayorder": 0,
 *            "label": "账套名称",
 *            "type": "table",
 *            "url": "/dataretriver/retrive?type=ref&id=e44eb7e5-1e59-494d-9343-0831a3f4a4b8&index=0",
 *            "name": "账套编号",
 *            "options": [],
 *            "width": 200,
 *            "must": true,
 *            "id": "672db682-5dc1-4870-922e-8e8acf0c723e",
 *            "displayfield": "账套名称"
 *        },
 *        {
 *           "valuefield": "年度",
 *            "defaultValue": null,
 *            "multiple": "1",
 *            "refitem": [
 *                "账套编号"
 *            ],
 *            "pageable": false,
 *            "displayorder": 1,
 *            "label": "账套年度",
 *            "type": "select",
 *            "url": "/dataretriver/retrive?type=ref&id=e44eb7e5-1e59-494d-9343-0831a3f4a4b8&index=1",
 *            "name": "年度期间",
 *            "options": [],
 *            "width": 170,
 *            "must": true,
 *            "id": "5c55e835-3510-49c2-b18f-dd297e70cb34",
 *            "displayfield": "年度"
 *        },
 *        {
 *            "valuefield": "value",
 *            "defaultValue": null,
 *            "multiple": "0",
 *            "refitem": [],
 *            "pageable": false,
 *            "displayorder": 5,
 *            "label": null,
 *            "type": "select",
 *            "url": "/dataretriver/retrive?type=ref&id=e44eb7e5-1e59-494d-9343-0831a3f4a4b8&index=5",
 *            "name": "科目级次",
 *            "options": [
 *                {
 *                    "label": "1级",
 *                    "value": "1"
 *                },
 *                {
 *                    "label": "到末级",
 *                    "value": "到末级"
 *                }
 *            ],
 *            "width": 80,
 *            "must": true,
 *            "id": "0e29906b-7af4-4560-85f4-b98b10916c51",
 *            "displayfield": "label"
 *        }
 *    ],
 *    "id": "e44eb7e5-1e59-494d-9343-0831a3f4a4b8",
 *    "sourceref": null
 * }
 * ~~~
 */
var AIPSearchPanel = /** @class */ (function (_super) {
    __extends(AIPSearchPanel, _super);
    function AIPSearchPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            singleDataSource: false,
            dataSourceId: "system",
            key: "primarykey",
            refitems: [],
            mustItems: [],
            allSortedItems: [],
            noRef: false,
            showAlert: false,
            form: {
                getFieldProps: function () {
                    return {};
                },
                validateFields: function (err, values) {
                    if (err) {
                        console.log(err);
                    }
                    else {
                    }
                },
                resetFields: function () {
                },
            },
            resetFields: function () {
            },
            id: "",
            createtime: "undefined",
            creator: "N/A",
            orderindex: 0,
            name: "",
            refType: "",
            description: ""
        };
        // private fields
        /**
         * 依赖参照相关数据结构,依赖参照map
         *
         {
            
            "年度期间": ["账套编号"],
    
             "账套年度": []
    
         }
         */
        _this._notifyItems = {};
        /** 参照项快表，通过参照项名称快速获取参照项对象 */
        _this._refsSnapshot = {};
        /**
         * 依赖参照链快表
         {
    
              "账套编号": ["账套年度"],
            
              "账套年度": []
          }
         */
        _this._refDepnedMaps = {};
        /**
         * 上下文路径
         */
        _this._contextPath = null;
        /**
         * 主控端缓存所有的值，以便快速完成调度
         */
        _this._cacheRefrenceValues = {};
        /**
         * 特殊的参数
         */
        _this._specialParams = {};
        /**
         * 默认参照项数据
         */
        _this._defaultParams = null;
        /**
         * 构建依赖参照需要的参数对象
         * @function
         *
         * @param {string} name 参照的名称
         * @returns {any[]} 返回依赖相关的参数
         */
        _this._buildRefParams = function (name, needFields) {
            var result = {};
            var keys = _this._notifyItems[name];
            keys.forEach(function (k) {
                var value = _this._cacheRefrenceValues[k] || "";
                // 特殊选择列表的默认值
                result[k] =
                    value === (0, utils_1.getTranslate)(null, Const_1.SELECT_DEFUALT_VALUE) ? "" : value;
            });
            // 确定是否有特殊参数(通过appendParam API从外部加入的参数，为了扩展使用)
            if (_this._specialParams) {
                for (var k in _this._specialParams) {
                    result[k] = _this._specialParams[k];
                }
            }
            // 最后加入needFields需要的参数（如果目前参数中没有的话）
            for (var i = 0, j = needFields.length; i < j; i++) {
                var needField = needFields[i];
                if (!needField || needField === "")
                    continue;
                if (!result[needField]) {
                    result[needField] = _this._cacheRefrenceValues[needField] || "";
                }
            }
            return result;
        };
        /**
         * 给参照提供必要的参数
         * @function
         *
         * @param paramKey  加入参数的名称
         * @param paramValue 加入的参数值
         */
        _this.appendParam = function (paramKey, paramValue) {
            _this._specialParams[paramKey] = paramValue;
        };
        /**
         * 构建指定条件的依赖快照
         * @function
         *
         * @param {string} name 条件名
         * @param {ReferenceItem[]} refrenceItems 所有参照对象列表
         * @param {Set<any>} cSet 各个条件的参照表
         */
        _this._buildRefDepends = function (name, refrenceItems, cSet) {
            var _tmps = [];
            refrenceItems.forEach(function (ref) {
                var n = ref.name;
                var refs = ref.refitem || [];
                if (refs.includes(name)) {
                    _tmps.push(n);
                    cSet.add(n);
                }
            });
            _tmps.forEach(function (_tmp) {
                _this._buildRefDepends(_tmp, refrenceItems, cSet);
            });
        };
        /**
         * 重新整理通知列表，将参考实际字段修正事件通知列表
         * @function
         *
         * @param {Map} refDepnedMaps 目前已有的通知列表
         * @param {any[]} refItems 参照记录
         */
        _this._afterBuildRefDepends = function (refDepnedMaps, refItems) {
            refItems.forEach(function (ref) {
                var refName = ref.name;
                var needFieldStr = ref.needfields;
                var needFields = (needFieldStr || "").split(",");
                needFields = needFields.filter(function (nf) { return nf !== ""; });
                needFields.forEach(function (nf) {
                    var notifiers = refDepnedMaps[nf] || [];
                    if (!notifiers.includes(refName)) {
                        notifiers.push(refName);
                    }
                    refDepnedMaps[nf] = notifiers;
                });
            });
        };
        /**
         * 将Map数据结构的key转为数组
         * @function
         *
         * @param {StringAnyMap} mp
         * @returns {string[]}
         */
        _this._mapKey2Array = function (mp) {
            var result = [];
            for (var k in mp) {
                result.push(k);
            }
            return result;
        };
        /**
         * 获取参照项的组件引用(非参照项对象)
         * @function
         *
         * @param {string} refName
         * @returns {RefItemInstance}
         */
        _this._getRefByName = function (refName) {
            return _this.refs[refName];
        };
        /**
         * 参照请求调度核心
         * @function
         *
         * @param {string} itemName 调度`itemName`条件的关联依赖组件请求，可选参数，为空则从头调用
         */
        _this._scheduler = function (itemName) {
            function _refItemLoadData(refItem, params, defaultValue) {
                if (params === undefined || params === null) {
                    params = {}; // TODO 没有条件的参照是否存在？ 也许存在
                }
                if (defaultValue) {
                    refItem.loadData(params, defaultValue);
                }
                else {
                    refItem.loadData(params);
                }
            }
            function _sendRequest(paramKeyArray, currentDependKey, self, defaultValue) {
                // 指定的参照(currentDependKey)在当前条件(paramKeyArray)下是否需要请求？
                var currentRef = self._refsSnapshot[currentDependKey];
                if (!currentRef)
                    return;
                var refs = currentRef.refitem;
                var keyInclude = true;
                if (refs && refs.length > 0) {
                    for (var i = 0, j = refs.length; i < j; i++) {
                        if (!paramKeyArray.includes(refs[i])) {
                            keyInclude = false;
                            break;
                        }
                    }
                }
                else {
                    keyInclude = false;
                }
                // console.log(currentDependKey + ' need loadData? ' + keyInclude);
                if (keyInclude) {
                    var current = self._getRefByName(currentDependKey);
                    if (current) {
                        _refItemLoadData(current, self._buildRefParams(currentDependKey, current.getNeedFields()), defaultValue);
                    }
                }
            }
            if (!itemName) {
                // 查找自身没有依赖的参照开始请求
                for (var i = 0, j = _this.state.allSortedItems.length; i < j; i++) {
                    var deps = _this.state.allSortedItems[i].refitem;
                    var name_1 = _this.state.allSortedItems[i].name;
                    if (!name_1)
                        continue;
                    if (!deps || deps.length === 0) {
                        // 启动所有没有依赖的组件
                        var current = _this._getRefByName(name_1);
                        if (current) {
                            var defaultValue = null;
                            if (_this._defaultParams !== null) {
                                defaultValue = _this._defaultParams[name_1];
                            }
                            _refItemLoadData(current, _this._buildRefParams(name_1, current.getNeedFields()), defaultValue);
                        }
                    }
                }
                return;
            }
            var _params = _this._mapKey2Array(_this._cacheRefrenceValues);
            var dependItems = _this._refDepnedMaps[itemName];
            if (dependItems && dependItems.length > 0) {
                dependItems.forEach(function (dep) {
                    var defaultValue = null;
                    if (_this._defaultParams !== null) {
                        defaultValue = _this._defaultParams[dep];
                    }
                    _sendRequest(_params, dep, _this, defaultValue);
                });
            }
        };
        /**
         * 参数数据项值改变通知
         * @function
         *
         * @param {string} itemName 参照名
         * @param {string | null} value 参照当前值
         */
        _this._refItemValueChange = function (itemName, value) {
            // console.log(`${itemName} => ${value}`); // Debug output
            // 先删除自身改变会造成有依赖的组件的状态
            var needCleanItems = _this._refDepnedMaps[itemName];
            if (needCleanItems && needCleanItems.length > 0) {
                needCleanItems.forEach(function (needCleanItem) {
                    var current = _this._getRefByName(needCleanItem);
                    if (current)
                        current.clear();
                    delete _this._cacheRefrenceValues[needCleanItem]; // 清理本地相关组件的缓存值
                });
            }
            // 处理当前参照的值
            if (value === null || value === "undefined" || value === "") {
                delete _this._cacheRefrenceValues[itemName];
            }
            else {
                _this._cacheRefrenceValues[itemName] = value;
            }
            // 开始调度依赖的参照请求
            _this._scheduler(itemName);
        };
        /**
         * 重新初始化部分对象变量
         * @function
         */
        _this._resetState = function () {
            // 重新初始化部分对象变量
            _this._notifyItems = {};
            _this._refsSnapshot = {};
            _this._refDepnedMaps = {};
        };
        /**
         * 载入（初始化）参照
         * @function
         *
         * @param {StringStringMap} params 初始化参数 **可选**
         */
        _this._loadRefrences = function (params) {
            // 如果是带了参数，那么就当默认参数处理
            if (params && !Utils_1.default.isEmptyParam(params)) {
                _this._defaultParams = params;
            }
            var getData = _this.props.service.loadRefrence;
            // 请求模型参照信息
            getData(_this.props.refid).then(function (resp) {
                if (resp.msg !== "success") {
                    // 请求数据状态异常处理
                    Message_1.default.showMessage(resp.msg || (0, utils_1.getTranslate)(null, "请求数据异常"), "error");
                    _this.props.loadedfunc && _this.props.loadedfunc();
                    return;
                }
                try {
                    var modelRef_1 = resp.data;
                    modelRef_1.key = "D" + new Date();
                    var _mustItems_1 = [], _allSortedItems_1 = [];
                    if (!modelRef_1.refitems || modelRef_1.refitems.length === 0) {
                        // 没有参照项的处理
                        _this.setState({
                            noRef: true,
                        });
                        _this.props.loadedfunc && _this.props.loadedfunc(true, modelRef_1); // 回调时传入立即查询的标记
                        return;
                    }
                    _this._resetState();
                    var references = modelRef_1.refitems;
                    var slimReference = references.filter(function (item) {
                        return item.hidden !== true;
                    });
                    // 先分开必选参照和可选参照
                    slimReference.forEach(function (item) {
                        var itemName = item.name;
                        if (!itemName)
                            throw "reference item name is empty";
                        item.key = itemName;
                        if (item.must) {
                            _mustItems_1.push(item);
                        }
                        _this._refsSnapshot[itemName] = item; // 快表
                        _allSortedItems_1.push(item);
                        // 处理条件依赖关系，以便参照发生变化后通知相关参照
                        if (item.refitem) {
                            var refnames = item.refitem || [];
                            _this._notifyItems[itemName] = refnames;
                            var dependSet = new Set();
                            _this._buildRefDepends(itemName, modelRef_1.refitems, dependSet);
                            var depends = Array.from(dependSet).filter(function (dep) { return dep !== itemName; });
                            _this._refDepnedMaps[itemName] = depends;
                        }
                    });
                    var singleDataSource = modelRef_1.singleDataSource;
                    if (singleDataSource) {
                        slimReference.forEach(function (item) {
                            item.dsId = modelRef_1.dataSourceId;
                        });
                    }
                    modelRef_1.refitems = slimReference;
                    // 重新处理事件通知队列(补充SQL字段内的信息)
                    _this._afterBuildRefDepends(_this._refDepnedMaps, modelRef_1.refitems);
                    // 排序
                    _allSortedItems_1.sort(function (a, b) {
                        return (a.displayorder || 0) - (b.displayorder || 0);
                    });
                    _this.setState(__assign(__assign({}, modelRef_1), { mustItems: _mustItems_1, allSortedItems: _allSortedItems_1, key: "priamry" + Math.random(), showAlert: false }), function () {
                        setTimeout(function () {
                            _this._scheduler();
                        }, 250);
                        _this.props.loadedfunc && _this.props.loadedfunc(true, modelRef_1);
                    });
                }
                catch (e) {
                    console.error(e.message);
                }
            })
                .catch(function (err) {
                // 请求异常处理
                var msg = err.message;
                console.error(msg);
                Message_1.default.showMessage(msg);
                _this.props.loadedfunc && _this.props.loadedfunc();
            });
        };
        /**
         * 注册全局服务，暴露部分信息到浏览器以便外部了解组件当前信息
         * @function
         */
        _this._installServices = function () {
            // 注册一个全局的方法以便获取足够的调试信息
            window.aipInspect = function () {
                console.log("--------组件内部信息--------");
                console.log("参照依赖信息(设计期依赖配置)");
                console.log(_this._notifyItems);
                console.log("参照关联信息(组件事件通知队列)");
                console.log(_this._refDepnedMaps);
                console.log("参照上下文");
                console.log(_this._contextPath);
                console.log("默认参数[*]");
                console.log(_this._defaultParams);
                console.log("参照当前值");
                console.log(_this._cacheRefrenceValues);
                console.log("当前组件的Props");
                console.log(_this.props);
                console.log("当前组件的state");
                console.log(_this.state);
                console.log("重新载入参照信息: window.reloadRefs");
                console.log("------------------------");
            };
            window.reloadRefs = function (params) {
                _this._loadRefrences(params);
            };
        };
        _this._uninstallServices = function () {
            delete window.aipInspect;
            delete window.reloadRefs;
        };
        /**
         * 获取当前状态选取的参数
         * @function
         *
         * @param {boolean} ignoreMust 是否忽略必填，如果为true，将返回目前已选的条件信息，如果为false，有必选条件未选将返回null
         * @returns {StringStringMap | null} 返回参数，可能值为 null或者StringStringMap
         */
        _this.getParams = function (ignoreMust) {
            var params = {};
            for (var key in _this._specialParams) {
                params[key] = _this._specialParams[key];
            }
            for (var key in _this.refs) {
                var current = _this._getRefByName(key);
                var v = current ? current.getValue() : null;
                if (v)
                    params[key] = v;
            }
            var mustValid = true;
            // 检索必须满足必选条件全部满足
            _this.state.mustItems.forEach(function (item) {
                var key = item.name;
                if (!params[key]) {
                    mustValid = false;
                }
            });
            if (ignoreMust) {
                return params;
            }
            else {
                if (!mustValid)
                    return null;
                return params;
            }
        };
        /**
         * 检索
         * @function
         *
         * @param {Event} e 事件对象，可选参数
         * @returns {void}
         */
        _this.search = function (e) {
            if (e) {
                try {
                    e.preventDefault();
                }
                catch (e) {
                }
            }
            var params = _this.getParams();
            if (params === null) {
                Message_1.default.showMessage((0, utils_1.getTranslate)(null, "请将必填选项填写完毕!"));
                return;
            }
            // 开始记录当前的条件
            // if (this._storeCacheFuncs) {
            //     this._storeCacheFuncs.forEach((fn: (id: string, values: StringStringMap) => void) => {
            //         fn(this.state.id, this._cacheRefrenceValues);
            //     });
            // }
            _this.props.doSearch && _this.props.doSearch(params);
        };
        /**
         * 重新载入所有参照数据
         * @function
         */
        _this.reload = function () {
            _this._loadRefrences();
        };
        /**
         * 清空所有参照项的值
         * @function
         *
         * @param {Event} e 事件对象，可选参数
         */
        _this.clear = function (e) {
            if (e) {
                try {
                    e.preventDefault();
                }
                catch (e) {
                }
            }
            for (var k in _this.refs) {
                _this.refs[k].clear();
            }
            _this._defaultParams = null; // 初始值清除
            _this._scheduler(); // 重启搜索条件
            _this.props.doClear && _this.props.doClear();
        };
        /**
         * 根据给定的path获取上下文路径
         * @function
         *
         * @param {string} path
         * @returns {string}
         */
        _this._getContextPath = function (path) {
            if (!_this._contextPath) {
                try {
                    var paths = path.split("//");
                    var requestUrls = paths[1].split("/");
                    var idx = -1;
                    for (var i = 0; i < requestUrls.length; i++) {
                        if (requestUrls[i] === "refrence" ||
                            requestUrls[i] === "dataretriver") {
                            idx = i - 1;
                            break;
                        }
                    }
                    _this._contextPath = requestUrls[idx];
                }
                catch (e) {
                    return path;
                }
            }
            return _this._contextPath;
        };
        /**
         * 确定当前的参照是否可以自动搜索
         *
         * @returns {boolean} 是否可以自动搜索
         */
        _this.canAutoSearch = function () {
            // 无参照，可以自动搜索
            if (_this.state.noRef)
                return true;
            // 有参照
            var musts = [];
            for (var k in _this.refs) {
                _this.refs[k].props.must && musts.push(k);
            }
            if (musts.length === 0)
                return true;
            // 如果有必选条件，不可以自动搜索，需要手动点击搜索
            return false;
        };
        return _this;
    }
    /**
     * 注册新的组件，如果已存在，将覆盖原有组件实现
     *
     * @param {string} componentName
     * @param {any} componentClass
     */
    AIPSearchPanel.registComponent = function (componentName, componentClass) {
        if (ComponentMap[componentName]) {
            console.warn("component ".concat(componentName, " is exist, it will be replaced"));
        }
        ComponentMap[componentName] = componentClass;
    };
    /**
     * 获取参照系统已经注册的组件信息
     * 返回Map为 {compnentName: componentClass}
     *
     * @function
     *
     * @returns {StringAnyMap}
     */
    AIPSearchPanel.getRegistedComponents = function () {
        return ComponentMap;
    };
    /**
     * React component lifecycle method
     */
    AIPSearchPanel.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.appendSpecialParam) {
            this._specialParams = this.props.appendSpecialParam() || {};
        }
        if (this.props.loadCacheFn) {
            // params object like {账套编号: "001", 年度期间: "'2016','2017'", 开始期间: "201601", 结束期间: "201712", 科目级次: "1"}
            // like {账套编号: "001", 年度期间: "'2016'", 开始期间: "201601", 结束期间: "201612", 科目级次: "1"}
            this.props.loadCacheFn(this.props.refid).then(function (params) {
                _this._defaultParams = params || {};
                _this._loadRefrences();
            });
        }
        else {
            this._defaultParams = null;
            this._loadRefrences();
        }
        this._installServices();
    };
    /**
     * React component lifecycle method
     */
    AIPSearchPanel.prototype.componentWillUnmount = function () {
        this._uninstallServices();
    };
    /**
     * 渲染每个参照项的组件
     * @function
     *
     * @param {ReferenceItem} refItem 参照项对象
     * @param {number} idx 序号
     * @returns {ReactNode}
     */
    AIPSearchPanel.prototype._eachRender = function (refItem, idx) {
        // 复制一份对象(浅复制)
        var item = Object.assign({}, refItem);
        var conditionType = item.type || "text";
        var service = this.props.service;
        delete item.value;
        item.key = item.ref = item.name; // 父组件通过名字可以获取到子组件对象
        item.refItemValueChange = this._refItemValueChange; // 核心调度例程
        var backDrop = this.props.backDrop;
        if (backDrop === undefined) {
            backDrop = true;
        }
        if (conditionType === "tree") {
            item.title = item.name;
            item["backDrop"] = backDrop;
        }
        else if (conditionType === "select") {
            item.placeholder = (0, utils_1.getTranslate)(null, Const_1.SELECT_DEFUALT_VALUE);
            item.defaultValue = (0, utils_1.getTranslate)(null, item.defaultValue || Const_1.SELECT_DEFUALT_VALUE);
        }
        else if (conditionType === "table") {
            item["backDrop"] = backDrop;
            item.showLoading = true;
            item.form = {
                getFieldProps: function () {
                    return {};
                },
                getFieldError: function () {
                },
                validateFields: function (err, values) {
                    if (err) {
                        console.log(err);
                    }
                    else {
                        console.log("提交成功", values);
                    }
                },
                resetFields: function () {
                },
            };
        }
        /**
         * item数据形态
         *        {
         *           "valuefield": "年度",
         *            "defaultValue": null,
         *            "multiple": "1",
         *            "refitem": [
         *                "账套编号"
         *            ],
         *            "pageable": false,
         *            "displayorder": 1,
         *            "label": "账套年度",
         *            "type": "select",
         *            "url": "/dataretriver/retrive?type=ref&id=e44eb7e5-1e59-494d-9343-0831a3f4a4b8&index=1",
         *            "name": "年度期间",
         *            "options": [],
         *            "width": 170,
         *            "must": true,
         *            "needfields": "",
         *            "id": "5c55e835-3510-49c2-b18f-dd297e70cb34",
         *            "displayfield": "年度"
         *        }
         */
        var must = item.must, needfields = item.needfields, props = __rest(item, ["must", "needfields"]);
        var needFields = (needfields || "").split(",");
        var C = ComponentMap[conditionType];
        var labelText = item.label || item.name || "未命名";
        props.label = labelText; // 对象添加 label 属性
        props.itemIndex = idx; // 对象添加 itemIndex 属性
        props.refId = this.props.refid; // 对象添加 refId 属性
        props.refItemValueChange = this._refItemValueChange; // 绑定值变化响应事件
        this.props.fetchCallback &&
            (props.fetchCallback = this.props.fetchCallback); // 绑定获取数据成功的回调事件
        var labelWidth = labelText.length * 15 + 20;
        if (must)
            labelWidth = labelWidth + 12;
        var divWidth = labelWidth + (props.width || 200);
        props.encryption = this.props.encryption || false; // 对象添加 encryption 属性，是否启用加密
        var loadData = service.loadRefrenceData;
        props.loadData = loadData;
        var _key = item.name;
        props.key = _key + "_" + Math.random().toString();
        props.needFields = needFields || [];
        return (React.createElement("div", { key: "div" + _key, style: { width: divWidth, float: "left", height: 42, marginRight: 10 } },
            React.createElement("label", { key: "label" + _key },
                (0, utils_1.getTranslate)(null, labelText),
                " ",
                React.createElement("span", { className: "mustinputlabelstar" }, must ? "*" : "")),
            React.createElement(C, __assign({ size: "sm", must: must }, props))));
    };
    AIPSearchPanel.prototype.render = function () {
        var _this = this;
        if (this.state.noRef) {
            return (React.createElement(NoRefSearch_1.default, { doSearch: this.props.doSearch, searchBtnText: (0, utils_1.getTranslate)(null, this.props.searchBtnText || "查询") }));
        }
        var allItems = __spreadArray([], this.state.allSortedItems, true);
        return (React.createElement("div", { className: "aip-search-bar" },
            React.createElement("div", { className: "aip-search-conds" }, allItems.map(function (item, idx) {
                return _this._eachRender(item, idx);
            })),
            React.createElement("div", { className: "aip-search-action" },
                React.createElement(tinper_bee_1.Button, { className: "aip-search-submit-btn", colors: "primary", size: "sm", onClick: this.search },
                    React.createElement(tinper_bee_1.Icon, { type: "uf-search" }),
                    (0, utils_1.getTranslate)(null, this.props.searchBtnText || "查询")),
                this.props.disableClear ? (React.createElement(React.Fragment, null)) : (React.createElement(tinper_bee_1.Button, { shape: "border", className: "aip-search-clean-btn", bordered: true, size: "sm", onClick: this.clear },
                    React.createElement(tinper_bee_1.Icon, { type: "uf-qingkong" }),
                    (0, utils_1.getTranslate)(null, this.props.cleanBtnText || "重置"))))));
    };
    return AIPSearchPanel;
}(react_1.PureComponent));
exports.default = AIPSearchPanel;
